export type IPageInfo = any;
export interface IPageInfoResponse {
  page: number;
  size: number;
  totalItems: number;
  totalPages: number;
}
/* export interface IPageInfo {
  size: number;
  page: number;
  totalItems: number;
  totalPages: number;
  sortField?: string;
  sortOrder?: string;
} */

export interface IDeleteRecordResponse {
  data: {
    affected: number;
    raw: any[];
  };
}

export type IRecordId = string | number;

export enum SortOrder {
  ASC = 'asc',
  DESC = 'desc',
}
